import * as React from "react";
import Backdrop from "../../../../../../Backdrop/Backdrop/Backdrop.js";
import { useDrawer } from "../../../../../context/Drawer/context/DrawerContext.js";
/* empty css                    */
const DrawerBackdrop = () => {
  const { isOpen, close } = useDrawer();
  return /* @__PURE__ */ React.createElement(Backdrop, { className: "drawer-backdrop", onClick: close, isVisible: isOpen, animate: true });
};
export {
  DrawerBackdrop
};
//# sourceMappingURL=DrawerBackdrop.js.map
